import { render, staticRenderFns } from "./enterSecretQuestionPage.vue?vue&type=template&id=2c37ad50&scoped=true"
import script from "./enterSecretQuestionPage.vue?vue&type=script&lang=js"
export * from "./enterSecretQuestionPage.vue?vue&type=script&lang=js"
import style0 from "./enterSecretQuestionPage.vue?vue&type=style&index=0&id=2c37ad50&prod&lang=scss"
import style1 from "./enterSecretQuestionPage.vue?vue&type=style&index=1&id=2c37ad50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c37ad50",
  null
  
)

export default component.exports